const actionType = {
    GET_ALL_DD_CONFIGURATION_SUCCESS: 'GET_ALL_DD_CONFIGURATION_SUCCESS',
    GET_DD_CONFIGURATION_SUCCESS: 'GET_DD_CONFIGURATION_SUCCESS',
    GET_ALL_DEFAULT_DICTIONARIES_SUCCESS: 'GET_ALL_DEFAULT_DICTIONARIES_SUCCESS',
    GET_ALL_DD_CONFIGURATION_SUCCESS_LINKED: 'GET_ALL_DD_CONFIGURATION_SUCCESS_LINKED',
    GET_DD_PENDING_FILE_UPLOADS: 'GET_DD_PENDING_FILE_UPLOADS',
};
export default actionType;
